<template>
	<div class="watch-dashboard-widget biometric-data-widget">
		<div class="watch-dashboard-widget-header">
			<router-link :to="{ name: 'WatchBiometric', params: { user_uid: user_uid, watch_id: watch_id } }" class="header-link">
				<h1>{{ $t('base.watch.biometric') }}</h1>
				<div v-if="mostRecentDate" class="date-time">
					<span class="date">{{ date(mostRecentDate) }}</span>
					<span class="time">{{ time(mostRecentDate) }}</span>
				</div>
			</router-link>
		</div>
		<div class="watch-dashboard-widget-body">
			<spinner v-if="readings.loading"/>
			<error-box v-else-if="readings.error" :error="readings.error"/>
			<div v-else>
				<div v-if="readings.data.length" class="readings">
					<router-link v-for="reading in readings.data" :key="reading.type_id" :to="{ name: 'WatchBiometricView', params: { user_uid: user_uid, watch_id: watch_id, type: type(reading.type_id) } }" class="reading-link">
						<biometric-reading :reading="reading"/>
					</router-link>
				</div>
				<p v-else>{{ $t('readings.general.no_readings') }}</p>
			</div>
		</div>
	</div>
</template>

<script>
import Readings from '@/utils/readings'
import BiometricReading from './biometric/BiometricReading'
export default {
	components: {
		BiometricReading
	},
	props: [
		'user_uid',
		'watch_id',
		'readings'
	],
	computed: {
		mostRecentDate () {
			let date = null
			this.readings.data.forEach(element => {
				if (new Date(element.datetime) > date) {
					date = element.datetime
				}
			})
			return date
		}
	},
	methods: {
		date (date) {
			return this.$moment(date).format('D MMM')
		},
		time (date) {
			return this.$moment(date).format('HH:mm')
		},
		type (type) {
			return Readings.readingTypes.get(type).route
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/watch/widgets/BiometricDataWidget.vue